import { ButtonsCallback } from "@components/dev-features-dialog/features";

/** Keys identifying which navigation action a dev page triggers */
export type DevPageNavigationKey = "aboutProducts" | "testingImpersonation";

/** Configuration for a navigable page shown in the dev tools dialog */
export interface DevPage {
  /** Display name to show in the table */
  label: string;

  /** A description of what this page is for */
  description: string;

  /** The key identifying which navigation action to run */
  navigationKey: DevPageNavigationKey;

  /** Whether the page should be hidden in production environments */
  isHiddenInProduction?: boolean;
}

/** A page item ready to be rendered in the pages table */
export interface DevPageItem {
  /** Display name to show in the table */
  label: string;

  /** A description of what this page is for */
  description: string;

  /** Callback to navigate to the page */
  onOpen: ButtonsCallback;
}

/**
 * Pages that can be opened from the dev tools dialog.
 */
export const DEV_PAGES: DevPage[] = [
  {
    label: "About Products",
    description: "View the products catalog and feature availability details",
    navigationKey: "aboutProducts",
  },
  {
    label: "Testing Impersonation",
    description:
      "Test impersonation login flows. Not available in production environments",
    navigationKey: "testingImpersonation",
    isHiddenInProduction: true,
  },
];
